<template>

<div>
<div class="input_columns_wrap">

<div class="input_columns_item" v-for="(item,index) in data.columns" v-if="inputdata.length">

	<template v-if="item.translations.length">
      <template v-if="item.type=='readonly'">
      <label  v-for="element in item.translations" v-show="element.language_id == $store.state.auth.user.preflang_id" class="text-xs">
      <b>{{element.translation}}</b>
    </label>
    </template>
    <template v-else>
        <label  v-for="element in item.translations" v-show="element.language_id == $store.state.auth.user.preflang_id" class="text-xs"><b>{{element.translation}}</b>
          <template v-if="item.is_required">
            <template v-if=" !inputdata[index].value">
              <template v-if="item.type=='custom' || item.type=='readonly'">
                
              </template>
              <template v-else-if="inputdata[index].value===0">
                <span class="material-icons md-16 ml-3 text-green-300"    
                  v-tooltip.right="{ value: $store.state.languages.lang_phrases.tamamlandi, disabled: false,class: 'custom-top-tooltip' }">
                  check_circle
                  </span>
              </template>
              <template v-else>
                <span class="material-icons md-16 ml-3 text-yellow-400"      
              v-tooltip.right="{ value: $store.state.languages.lang_phrases.gerekli, disabled: false,class: 'custom-top-tooltip' }">
              emergency
              </span>
              </template>
               
            </template>
            <template v-else>
              <span class="material-icons md-16 ml-3 text-green-300"    
          v-tooltip.right="{ value: $store.state.languages.lang_phrases.tamamlandi, disabled: false,class: 'custom-top-tooltip' }">
          check_circle
          </span>
            </template>        
        </template>
        </label>
    </template>
	</template>
	<template v-else>
    <template v-if="item.type=='readonly'" >
  		<label class="text-xs">{{item.name}}</label>
    </template>
    <template v-else>
      <label class="text-xs">{{item.name}}</label>
    </template>
	</template>

<template v-if="item.type=='readonly'">
    <template v-if="item.translations.length">
    <h4 class="text-primary font-semibold mt-3 mb-2" v-for="element in item.translations" v-show="element.language_id == $store.state.auth.user.preflang_id">{{element.readonly}}</h4>
  </template>
  <template v-else>
    <h4>{{item.name}}</h4>
  </template>
</template>

<template v-else-if="item.type=='custom'">
  <ColumnCalculation :data="item"></ColumnCalculation>
</template>


<template v-else>

  <template v-if="data.read_only_state">
    <template v-if="inputdata[index].value">
      <template  v-if="item.type=='number'">
        <p class="text-primary">{{ $filters.numberformat( inputdata[index].value)}}</p>
      </template>
      <template  v-if="item.type=='text'">
        <p class="text-primary">{{inputdata[index].value}}</p>
      </template>
      
      
    </template>
    <template v-else>
      <p class="text-primary">-</p>
    </template>
    
  </template>
  <template v-if="!data.read_only_state">

    <ColumnInputItem :data="data" :columnvalue="inputdata[index].value" :index="index" :column="item" :ref="'columninput_'+item.id" @columnFieldSubmitted="columnFieldSubmitted"></ColumnInputItem>
    
    <!--
     <template v-if="item.type=='text'" >
    <InputText   v-model="inputdata[index].value"  class="w-full p-inputtext-sm mb-0 mt-2"  @input="fieldChanged($event,index,item.type)" :disabled="data.submissions.length && data.submissions[0].is_nulled"/>
    </template>
    <template v-if="item.type=='number'" >
    <InputNumber  v-model="inputdata[index].value" mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"    class="w-full p-inputtext-sm mb-0 mt-2"   @input="fieldChanged($event,index,item.type)" :disabled="data.submissions.length && data.submissions[0].is_nulled"  />
    <small  class="p-error pt-2 hidden" :ref="'column_'+index"> {{val_err_message}}</small>
    </template>
    -->
    


  </template>
  


 

</template>


</div>

</div>

</div>

</template>

<script>
import ColumnCalculation from "./ColumnCalculation"
import ColumnInputItem from "./ColumnInputItem"


export default {

  name: 'ColumnsType',
  props:["data"],
  components:{ColumnCalculation,ColumnInputItem},
  data () {
    return {
    	inputdata:[],
    	intervalobj:null,
      char_length_err_message:null,
      val_err_message:null,
    }
  },
  computed:{
    propdata()
    {

      if(this.data.submissions.length>0)
      {
        let propdata = this.data.submissions[0].submission_text

        return propdata
      }
    }
  },
  watch:{
    propdata(newval)
    {
      console.log("propdata")
      data =  JSON.parse(newval)
      console.log(data)
      if(newval.length>0)
      {
        this.arrangeInputTypes(this.data.submissions)
      }
     else
      {
        for(let item of this.data.columns)
        {
          let obj = {
            id:item.id,
            value:null
          }
          this.inputdata.push(obj)
        }
      }
      
    },
  },
  mounted()
  {
    if(this.data.submissions.length>0)
    {
      this.arrangeInputTypes(this.data.submissions)
    }
   else
    {
      for(let item of this.data.columns)
      {
        let obj = {
          id:item.id,
          value:null
        }
        this.inputdata.push(obj)
      }
    }
    
  },
  methods: {
    arrangeInputTypes(submissions)
    {
        this.inputdata = []
        let data = []
        if(submissions[0].submission_text)
        {
            data =  JSON.parse(submissions[0].submission_text)
        }
          
        let columns = this.data.columns
        for(let item of columns)
        {
          let element = data.find((obj)=>{return obj.id == item.id})
          if(element)
          {
            this.inputdata.push(element)
          }
          else
          {
            let obj = {
              id:item.id,
              value:null
            }
            this.inputdata.push(obj)
          }
          
        }
     

    },
  	
    columnFieldSubmitted(data)
    {
      console.log("emitted colum data")
      console.log(data)
      this.inputdata[data.index].value = data.inputdata
      console.log(this.inputdata)
      //return false
      this.submitInputData() 

    },
  	submitInputData()
  	{
  		//clearInterval(this.intervalobj);
  		let formdata = new FormData()
  		formdata.append("text",JSON.stringify(this.inputdata))
  		formdata.append("type","columns")
  		formdata.append("flowsupplier_id",this.$store.state.audit.audit.flowsupplier.uuid)
  		//return false
  		this.submitInputFieldAuditSubmission(formdata,this.data.id)
  	},
  }
};
</script>

<style lang="css" scoped>
</style>